import './vue-flags'
import { createApp } from 'vue'
import App from './App.vue'
import * as cssText from 'bundle-text:./styles/tailwind.css';

const Root = (App as any).default ?? App

class MetalsCalculatorWidget extends HTMLElement {
  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: 'open' })
    const container = document.createElement('div')
    const style = document.createElement('style')
    style.textContent = cssText as unknown as string
    shadowRoot.appendChild(container)
    shadowRoot.appendChild(style)

    // Read the "metal" attribute at mount
    const metal = this.getAttribute('metal') ?? 'default'
    const configId = this.getAttribute('config-id') ?? 'default'
    const theme = this.getAttribute('theme') ?? 'default'

    // Pass as prop to Vue
    const props = { metal, configId, theme }

    createApp(Root, props).mount(container)
  }
}

if (!customElements.get('metals-calculator-widget')) {
  customElements.define('metals-calculator-widget', MetalsCalculatorWidget)
}
